<template>
    <div class="criteia-body">
        <div class="body-item criteria" v-for="(item, key) in getCriteria.data" :key="key">
            <div class="item-combo">
                <p>Критерий</p>
                <!-- <span style="height: 300px;" v-if="key == 1">
                    {{ item.list }} ----- {{ item.criteriaId }}
                </span> -->
                <v-autocomplete
                    :readonly="getFlagReadonly"
                    hide-details
                    label=""
                    outlined
                    height="46"
                    :items="item.list"
                    @change="switchSave({
                        obj: item,
                        url: 'DiaTest/AddOrUpdateCriteria',
                        index: key,
                        nameGroup: 'criteria',
                        nameProperty: 'data'
                    })"
                    @focus="updateSelectList(item)"
                    @click="updateSelectList(item)"
                    placeholder="Выберите критерий"
                    item-text="name"
                    item-value="id"
                    class="item-combo__select"
                    v-model="item.criteriaId"
                />
            </div>
            <div class="item-combo" style="max-width: 236px">
                <p>Баллы за каждый верный ответ</p>
                <input
                    :readonly="getFlagReadonly"
                    class="item-input"
                    v-model="item.criteriaMaxValue"
                    type="number"
                    placeholder="Введите кол-во баллов"
                    @focus="item.criteriaMaxValue = focusInNumber(item.criteriaMaxValue)"
                    v-on:focusout="item.criteriaMaxValue = focusOutNumber(item.criteriaMaxValue)"
                    @input="saveThroughTime({
                        obj: item,
                        url: 'DiaTest/AddOrUpdateCriteria',
                        index: key,
                        nameGroup: 'criteria',
                        nameProperty: 'data'
                    }, true); item.inputText = true;"
                    @blur="switchSave({
                        obj: item,
                        url: 'DiaTest/AddOrUpdateCriteria',
                        index: key,
                        nameGroup: 'criteria',
                        nameProperty: 'data'
                    }, true)"
                >
            </div>
            <div class="item-combo" style="max-width: 236px">
                <p>Баллы за каждый неверный ответ</p>
                <input
                    :readonly="getFlagReadonly"
                    class="item-input"
                    v-model="item.criteriaMinValue"
                    type="number"
                    placeholder="Введите кол-во баллов"
                    @focus="item.criteriaMinValue = focusInNumber(item.criteriaMinValue)"
                    v-on:focusout="item.criteriaMinValue = focusOutNumber(item.criteriaMinValue)"
                    @input="saveThroughTime({
                        obj: item,
                        url: 'DiaTest/AddOrUpdateCriteria',
                        index: key,
                        nameGroup: 'criteria',
                        nameProperty: 'data'
                    }, true); item.inputText = true;"
                    @blur="switchSave({
                        obj: item,
                        url: 'DiaTest/AddOrUpdateCriteria',
                        index: key,
                        nameGroup: 'criteria',
                        nameProperty: 'data'
                    }, true)"
                >
            </div>
            <div class="item-combo">
                <p>Ссылка на обучающий материал</p>
                <input
                    :readonly="getFlagReadonly"
                    class="item-input"
                    v-model="item.url"
                    placeholder="Введите ссылку на обучающий материал"
                    @input="saveThroughTime({
                        obj: item,
                        url: 'DiaTest/AddOrUpdateCriteria',
                        index: key,
                        nameGroup: 'criteria',
                        nameProperty: 'data'
                    }, true); item.inputText = true;"
                    @blur="switchSave({
                        obj: item,
                        url: 'DiaTest/AddOrUpdateCriteria',
                        index: key,
                        nameGroup: 'criteria',
                        nameProperty: 'data'
                    }, true)"
                >
            </div>
            <div v-if="!getFlagReadonly" class="switch">
                <v-btn @click.prevent="deleteCriterias(item)" class="mt-7" color="error" large>
                    <v-icon color="white">mdi-delete</v-icon>
                </v-btn>
            </div>
        </div>

        <button
            v-if="!getFlagReadonly"
            type="button"
            @click="addCriteria()"
            :disabled="addDisabled()"
            class="custom-button"
            :class="{ 'btn-disabled': addDisabled() }"
        >
            + Добавить
        </button>

        <TimeoutSnackbar :options="snackbar" />
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';
import debounce from 'lodash.debounce';

export default {
    name: 'Criteria',
    components: { TimeoutSnackbar },
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl',
            getCriteria: 'createDiagnosticTest/getCriteria',
            getFlagReadonly: 'createDiagnosticTest/getFlagReadonly'
        })
    },
    data: () => ({
        snackbar: {
            show: false,
            text: null,
            color: null,
            timeout: -1
        },
        criteriaTypes: []
    }),
    methods: {
        ...mapActions({
            getCriteriaByTestId: 'createDiagnosticTest/getCriteriaByTestId',
            saveInline: 'createDiagnosticTest/saveInline',
            deleteCriteria: 'createDiagnosticTest/deleteCriteria'
        }),
        ...mapMutations({
            addCriteria: 'createDiagnosticTest/addCriteria',
            saveListForCriteria: 'createDiagnosticTest/saveListForCriteria'
        }),
        focusInNumber(value) {
            return value ? value : null;
        },
        focusOutNumber(value) {
            return value ? value : 0;
        },
        updateSelectList(item) {
            let existingIds = this.getCriteria.data.map(x => x.criteriaId).filter((f) => f);

            let selectList = this.criteriaTypes.filter(x => {
                return existingIds.find(y => y === x.id) === undefined || x.id === item.criteriaId;
            });

            item.list = selectList;
        },
        addDisabled() {
            if (this.getCriteria.data.length === 0) {
                return false;
            }

            let index = this.getCriteria.data.length - 1;
            let last = this.getCriteria.data[index];

            if (last.criteriaId === null) {
                return true;
            }

            return this.getCriteria.listAll ? this.getCriteria.data.length >= this.getCriteria.listAll.length : false;
        },
        switchSave(obj, checkSave) {
            // Если мы сохраняем текстовое поле, то проверим на повторное сохранение
            if(checkSave) {
                if(!obj.obj.inputText) return;
            }

            obj.obj.criteriaMaxValue = this.focusOutNumber(obj.obj.criteriaMaxValue);
            obj.obj.criteriaMinValue = this.focusOutNumber(obj.obj.criteriaMinValue);

            let rightAnswersMaxScore = this.getMaxScoreForRightAnswers(this.getCriteria.data);

            if (rightAnswersMaxScore < 0) {
                this.snackbar = { text: 'Ошибка сохранения, сумма баллов за правильные ответы не может быть отрицательной!', color: 'error', timeout: 3000, show: true };
                return;
            }

            if (rightAnswersMaxScore > 100) {
                this.snackbar = { text: 'Ошибка сохранения, сумма баллов за правильные ответы не может превышать 100!', color: 'error', timeout: 3000, show: true };
                return;
            }

            let wrongAnswersMaxScore = this.getMaxScoreForWrongAnswers(this.getCriteria.data);

            if (wrongAnswersMaxScore < 0) {
                this.snackbar = { text: 'Ошибка сохранения, сумма баллов за неправильные ответы не может быть отрицательной!', color: 'error', timeout: 3000, show: true };
                return;
            }

            if (wrongAnswersMaxScore > 100) {
                this.snackbar = { text: 'Ошибка сохранения, сумма баллов за неправильные ответы не может превышать 100!', color: 'error', timeout: 3000, show: true };
                return;
            }

            this.saveInline({
                obj: {
                    id: obj.obj.id ? obj.obj.id : undefined,
                    criteriaId: +obj.obj.criteriaId,
                    criteriaMaxValue: obj.obj.criteriaMaxValue,
                    criteriaMinValue: obj.obj.criteriaMinValue,
                    diaTestId: obj.obj.diaTestId,
                    url: obj.obj.url,
                },
                url: obj.url,
                index: obj.index,
                nameGroup: obj.nameGroup,
                nameProperty: obj.nameProperty
            })
            .then(() => {
                obj.obj.edite = false;
                obj.obj.inputText = false;
                this.snackbar = { text: 'Изменения сохранены успешно!', color: 'success', timeout: 3000, show: true };
            })
            .catch((error) => {
                if(error) {
                    obj.obj.inputText = false;
                    this.snackbar = { text: 'Ошибка сохранения данных, обратитесь к Администратору!', color: 'error', timeout: 3000, show: true };
                }
            })
        },
        saveThroughTime: debounce( function (obj, checkSave) {
            this.switchSave(obj, checkSave)
        }, 1000),
        getMaxScoreForRightAnswers(criteria) {
            let score = 0;

            for (let i = 0; i < criteria.length; i++) {
                score += +criteria[i].criteriaMaxValue;
            }

            return score;
        },
        getMaxScoreForWrongAnswers(criteria) {
            let score = 0;

            for (let i = 0; i < criteria.length; i++) {
                score += +criteria[i].criteriaMinValue;
            }

            return score;
        },
        deleteCriterias(item) {
            if(confirm('Вы уверены, что хотите удалить критерий ?')) {
                this.deleteCriteria(item);
            }
        }
    },
    created() {
        this.$http.get(`${this.apiUrl}DiaTest/GetAllCriteriaTypes`)
            .then((res) => {

                for (let i = 0; i < res.data.length; i++) {
                    res.data[i].id = +res.data[i].id
                }

                this.getCriteriaByTestId(this.$route.params.id)
                .then((resCriteria) => {
                    if(resCriteria.length === 0) {
                        this.addCriteria();
                    }

                    this.saveListForCriteria(res.data);
                });

                this.criteriaTypes = res.data;
            })
    }
}
</script>
